import { useEffect, useRef } from "react";
import { isHealthFeature } from "./HealthReport.types";
import { collectDescendantFeatureIds, collectUnhealthyExpansionIds, hasProblem } from "./healthTree";
const useExpansionCascade = (tree, lookup, rootId) => {
  const previousExpandedRef = useRef(tree.expandedState);
  useEffect(() => {
    if (tree.expandedState[rootId] === false) {
      tree.expand(rootId);
      return;
    }
    const previous = previousExpandedRef.current;
    const current = tree.expandedState;
    const changedIds = Array.from(/* @__PURE__ */ new Set([...Object.keys(previous), ...Object.keys(current)])).filter(
      (id) => Boolean(previous[id]) !== Boolean(current[id])
    );
    previousExpandedRef.current = current;
    if (changedIds.length !== 1) return;
    const changedId = changedIds[0];
    const subject = lookup[changedId];
    if (!subject || !isHealthFeature(subject)) return;
    const isNowExpanded = Boolean(current[changedId]);
    if (!isNowExpanded) {
      collectDescendantFeatureIds(subject).forEach((id) => tree.collapse(id));
    } else if (hasProblem(subject)) {
      collectUnhealthyExpansionIds(subject).forEach((id) => tree.expand(id));
    }
  }, [tree, lookup, rootId]);
};
export default useExpansionCascade;
